import React, { useEffect, useState, memo, createElement } from 'react';
import { Check, Star, ShieldCheck, Download, ChevronRight, Clock, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// 👉 ENLACE DE PAGO (checkout). Todos los botones de compra usan este link.
const CHECKOUT_URL = 'https://colorpack.store/cart/53653671379258:1';
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/aC8NCfW4miKQQv4QLsHBBv/principao.png',
  bono5: 'https://cdn.magicpatterns.com/uploads/1Qcg3L7LVxx2MnJcH9rysZ/bn55.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/dy5yqYXf5LYdXD9xfX8Cqj/juegos1.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/3uBD6jQ57RbMRQnE4i8dou/juegos2.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/c8V47JexbQm6cL7kSQXK6k/juegos_3.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/aekQa4cVXiwptxGyt11bf7/juegos4.png'
};
const TESTIMONIALS = [{
  name: 'Carmen R., 68 años',
  text: 'Compré este libro para mi esposo y ahora pasamos las tardes resolviendo los laberintos y sopas de letras. La letra grande es una bendición. ¡Totalmente recomendado!',
  image: 'https://images.unsplash.com/photo-1581579186913-46eaecf613c9?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Roberto M., 72 años',
  text: 'Me sentía un poco aburrido en casa, pero estos juegos me mantienen la mente ágil. Los imprimo poco a poco y los hago con mi café de la mañana.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Elena V., 65 años',
  text: 'Los bonos son increíbles. El calendario de retos me ha ayudado a crear una rutina. Ya no paso tanto tiempo viendo televisión.',
  image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Antonio G., 75 años',
  text: 'Excelente material. Mis nietos vienen los fines de semana y usamos los juegos extra para compartir en familia. Muy buena inversión.',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Marta L., 70 años',
  text: 'Es exactamente lo que buscaba. No necesito internet ni aplicaciones complicadas. Solo imprimo y disfruto. Gracias por pensar en nosotros.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&q=80'
}];
const RECENT_PURCHASES = [{
  name: 'María',
  country: 'Colombia'
}, {
  name: 'José',
  country: 'México'
}, {
  name: 'Ana',
  country: 'España'
}, {
  name: 'Carlos',
  country: 'Argentina'
}, {
  name: 'Teresa',
  country: 'Chile'
}, {
  name: 'Luis',
  country: 'Perú'
}];
export function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(RECENT_PURCHASES[0]);
  // Pixel oficial de Meta (snippet oficial de Facebook). Carga fbevents.js,
  // inicializa el Pixel y dispara PageView. typeof fbq === 'function' tras esto.
  // Envuelto en try/catch e inserción segura en <head> para que un eventual
  // error del script externo (cross-origin "Script error.") no tumbe la página
  // dentro del iframe de previsualización.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1923262095011710');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      // Silenciar errores del Pixel (p. ej. bloqueado en el iframe de preview)
      // para no interrumpir la renderización de la página.
      console.warn('Meta Pixel no se pudo inicializar:', err);
    }
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      const randomPurchase = RECENT_PURCHASES[Math.floor(Math.random() * RECENT_PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 5000);
    }, 20000); // Show every 20 seconds
    return () => clearInterval(interval);
  }, []);
  const scrollToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-800" data-id="element-0">
      {/* Top Banner */}
      <div className="bg-red-600 text-white text-center py-2 px-4 font-bold text-sm md:text-base" data-id="element-1">
        ⚠️ ATENCIÓN: OFERTA ESPECIAL CON 75% DE DESCUENTO SOLO POR HOY
      </div>

      {/* Hero Section */}
      <section className="pt-12 pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-2">
        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-3">
          500 Juegos para Mantener tu{' '}
          <span className="text-red-600" data-id="element-4">Mente Activa</span> y Disfrutar Cada
          Día
        </h1>

        <div className="max-w-3xl mx-auto mb-8" data-id="element-5">
          <img src={IMAGES.main} alt="Mente en Acción - 500 Juegos" className="w-full h-auto rounded-lg shadow-2xl border-4 border-white" data-id="element-6" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-700 mb-8" data-id="element-7">
          Más de{' '}
          <span className="text-red-600 underline" data-id="element-8">500 juegos imprimibles</span>{' '}
          para ejercitar la memoria, la atención, la lógica y la concentración
          de una forma entretenida, sencilla y desde casa.
        </h2>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-10 text-lg font-semibold text-gray-700" data-id="element-9">
          <div className="flex items-center gap-2" data-id="element-10">
            <Star className="text-yellow-500 fill-yellow-500" data-id="element-11" /> Letra grande y
            fácil de leer
          </div>
          <div className="flex items-center gap-2" data-id="element-12">
            <Star className="text-yellow-500 fill-yellow-500" data-id="element-13" /> Listo para
            imprimir
          </div>
          <div className="flex items-center gap-2" data-id="element-14">
            <Star className="text-yellow-500 fill-yellow-500" data-id="element-15" /> Ideal para
            adultos mayores
          </div>
        </div>

        <div className="bg-yellow-100 border-2 border-yellow-400 rounded-xl p-6 max-w-2xl mx-auto mb-8" data-id="element-16">
          <p className="text-2xl font-bold text-gray-900 mb-2" data-id="element-17">
            HOY POR SOLO $12 USD
          </p>
          <p className="text-gray-600 line-through mb-4" data-id="element-18">
            Precio Normal: $49 USD
          </p>

          <button onClick={scrollToCheckout} className="w-full bg-green-600 hover:bg-green-500 text-white font-extrabold text-2xl py-5 px-8 rounded-lg shadow-[0_8px_0_rgb(22,101,52)] hover:shadow-[0_4px_0_rgb(22,101,52)] hover:translate-y-1 transition-all flex items-center justify-center gap-3" data-id="element-19">
            ¡QUIERO MI ACCESO AHORA! <ChevronRight size={28} data-id="element-20" />
          </button>

          <div className="flex justify-center items-center gap-6 mt-6 text-sm font-bold text-gray-600" data-id="element-21">
            <div className="flex items-center gap-1" data-id="element-22">
              <ShieldCheck className="text-green-600" size={20} data-id="element-23" /> Pago 100%
              seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-24">
              <Download className="text-blue-600" size={20} data-id="element-25" /> Descarga
              inmediata
            </div>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="bg-white py-16 px-4" data-id="element-26">
        <div className="max-w-4xl mx-auto" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-28">
            ¿Sientes que un ser querido pasa demasiado tiempo frente al
            televisor sin una actividad que realmente lo mantenga entretenido?
          </h2>

          <div className="text-xl text-gray-700 space-y-6 leading-relaxed" data-id="element-29">
            <p data-id="element-30">
              Con el paso de los años es normal buscar actividades que mantengan
              la mente ocupada y hagan los días más entretenidos.
            </p>
            <p className="font-bold text-red-600" data-id="element-31">
              El problema es que la mayoría de opciones son aburridas,
              repetitivas o requieren usar tecnología complicada.
            </p>
            <p data-id="element-32">
              Por eso creamos <strong data-id="element-33">MENTE EN ACCIÓN™</strong>.
            </p>
            <p data-id="element-34">
              Un completo libro con más de 500 juegos cuidadosamente
              seleccionados para disfrutar un momento agradable mientras se
              ejercitan habilidades como la memoria, la atención y el
              razonamiento.
            </p>
            <p className="bg-yellow-100 p-4 rounded-lg border-l-4 border-yellow-500 font-bold" data-id="element-35">
              Todo con letra grande, diseño limpio y listo para imprimir.
            </p>
          </div>
        </div>
      </section>

      {/* Imagine Section */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-36">
        <div className="max-w-4xl mx-auto" data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-yellow-400" data-id="element-38">
            Imagina que cada día puedas dedicar solo 15 minutos a una actividad
            entretenida…
          </h2>

          <div className="grid md:grid-cols-2 gap-6 text-lg mb-12" data-id="element-39">
            {['Resolver nuevos retos.', 'Descubrir juegos diferentes.', 'Compartir momentos en familia.', 'Crear una rutina agradable.', 'Disfrutar aprendiendo cada día.'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-gray-800 p-4 rounded-lg border border-gray-700" data-id="element-40">
                <Check className="text-green-400 shrink-0" size={28} data-id="element-41" />
                <span data-id="element-42">{item}</span>
              </div>)}
          </div>

          <p className="text-center text-2xl font-bold mb-10" data-id="element-43">
            Todo desde la comodidad de casa.
          </p>

          <div className="text-center" data-id="element-44">
            <button onClick={scrollToCheckout} className="bg-yellow-500 hover:bg-yellow-400 text-gray-900 font-extrabold text-xl py-4 px-8 rounded-lg shadow-[0_6px_0_rgb(161,98,7)] hover:shadow-[0_3px_0_rgb(161,98,7)] hover:translate-y-1 transition-all" data-id="element-45">
              SÍ, QUIERO ESTO PARA MÍ O MI FAMILIA
            </button>
          </div>
        </div>
      </section>

      {/* What's inside */}
      <section className="py-16 px-4 bg-white" data-id="element-46">
        <div className="max-w-5xl mx-auto" data-id="element-47">
          <h2 className="text-4xl font-extrabold text-center mb-12" data-id="element-48">
            ¿Qué encontrarás dentro?
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-12" data-id="element-49">
            {['Sopas de letras gigantes', 'Encuentra las diferencias', 'Laberintos', 'Crucigramas fáciles', 'Juegos de lógica', 'Memoria visual', 'Asociación de imágenes', 'Secuencias', 'Buscar objetos', 'Acertijos', 'Juegos con números', 'Retos de concentración'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-gray-50 p-3 rounded border border-gray-200 shadow-sm" data-id="element-50">
                <Check className="text-green-600 shrink-0" size={24} data-id="element-51" />
                <span className="font-bold text-gray-700" data-id="element-52">{item}</span>
              </div>)}
          </div>

          <p className="text-center text-2xl font-bold text-red-600 mb-12" data-id="element-53">
            Y mucho más… En total recibirás más de 500 actividades listas para
            imprimir.
          </p>

          <div className="bg-blue-50 rounded-2xl p-8 border-2 border-blue-200" data-id="element-54">
            <h3 className="text-3xl font-bold text-center mb-8 text-blue-900" data-id="element-55">
              Diseñado especialmente para adultos
            </h3>
            <p className="text-center text-lg mb-8" data-id="element-56">
              A diferencia de otros libros:
            </p>

            <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-57">
              {['Tiene letra grande.', 'Es cómodo de leer.', 'Los ejercicios son claros.', 'No necesitas internet.', 'Puedes imprimir solo las páginas que quieras.', 'Puedes repetir los juegos cuando desees.'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-58">
                  <Check className="text-blue-600 shrink-0" size={24} data-id="element-59" />
                  <span className="text-lg font-medium" data-id="element-60">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-gray-100" data-id="element-61">
        <div className="max-w-6xl mx-auto" data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12" data-id="element-63">
            Lo que dicen quienes ya lo tienen...
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-64">
            {TESTIMONIALS.slice(0, 3).map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-lg border border-gray-200" data-id="element-65">
                <div className="flex text-yellow-400 mb-4" data-id="element-66">
                  {[...Array(5)].map((_, j) => <Star key={j} className="fill-current" size={20} data-id="element-67" />)}
                </div>
                <p className="text-gray-600 italic mb-6" data-id="element-68">"{t.text}"</p>
                <div className="flex items-center gap-4" data-id="element-69">
                  <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-70" />
                  <span className="font-bold text-gray-900" data-id="element-71">{t.name}</span>
                </div>
              </div>)}
          </div>

          <div className="grid md:grid-cols-2 gap-8 mt-8 max-w-4xl mx-auto" data-id="element-72">
            {TESTIMONIALS.slice(3, 5).map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-lg border border-gray-200" data-id="element-73">
                <div className="flex text-yellow-400 mb-4" data-id="element-74">
                  {[...Array(5)].map((_, j) => <Star key={j} className="fill-current" size={20} data-id="element-75" />)}
                </div>
                <p className="text-gray-600 italic mb-6" data-id="element-76">"{t.text}"</p>
                <div className="flex items-center gap-4" data-id="element-77">
                  <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-78" />
                  <span className="font-bold text-gray-900" data-id="element-79">{t.name}</span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* The Stack / Bonuses */}
      <section className="py-16 px-4 bg-white" data-id="element-80">
        <div className="max-w-4xl mx-auto" data-id="element-81">
          <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-4" data-id="element-82">
            Todo lo que recibirás hoy
          </h2>
          <p className="text-center text-xl text-red-600 font-bold mb-12" data-id="element-83">
            ¡Atención! Los siguientes bonos son GRATIS solo por el día de hoy.
          </p>

          {/* Main Product */}
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border-2 border-gray-200 mb-8 flex flex-col md:flex-row items-center gap-8 shadow-lg" data-id="element-84">
            <div className="w-full md:w-1/3" data-id="element-85">
              <img src={IMAGES.main} alt="Producto Principal" className="w-full rounded-lg shadow-md" data-id="element-86" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-87">
              <div className="uppercase text-sm font-bold text-gray-500 tracking-wider mb-2" data-id="element-88">
                Producto Principal
              </div>
              <h3 className="text-3xl font-extrabold text-gray-900 mb-2" data-id="element-89">
                MENTE EN ACCIÓN™
              </h3>
              <p className="text-xl text-gray-600 mb-4" data-id="element-90">
                Más de 500 juegos imprimibles.
              </p>
              <p className="text-2xl font-bold text-red-600" data-id="element-91">Valor: $49</p>
            </div>
          </div>

          {/* Bono 1 */}
          <div className="bg-green-50 rounded-2xl p-6 md:p-8 border-2 border-green-200 mb-8 flex flex-col md:flex-row items-center gap-8 shadow-lg relative overflow-hidden" data-id="element-92">
            <div className="absolute top-4 right-4 bg-red-600 text-white font-bold py-1 px-3 rounded-full text-sm transform rotate-12" data-id="element-93">
              ¡GRATIS HOY!
            </div>
            <div className="w-full md:w-1/3" data-id="element-94">
              <img src={IMAGES.bono1} alt="Bono 1" className="w-full rounded-lg shadow-md" data-id="element-95" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-96">
              <div className="uppercase text-sm font-bold text-green-600 tracking-wider mb-2" data-id="element-97">
                🎁 Bono 1
              </div>
              <h3 className="text-2xl font-extrabold text-gray-900 mb-2" data-id="element-98">
                Calendario de Retos de 90 Días
              </h3>
              <p className="text-lg text-gray-600 mb-4" data-id="element-99">
                Crea el hábito de realizar una actividad cada día.
              </p>
              <p className="text-xl font-bold text-gray-400 line-through" data-id="element-100">
                Valor: $19
              </p>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-purple-50 rounded-2xl p-6 md:p-8 border-2 border-purple-200 mb-8 flex flex-col md:flex-row items-center gap-8 shadow-lg relative overflow-hidden" data-id="element-101">
            <div className="absolute top-4 right-4 bg-red-600 text-white font-bold py-1 px-3 rounded-full text-sm transform rotate-12" data-id="element-102">
              ¡GRATIS HOY!
            </div>
            <div className="w-full md:w-1/3" data-id="element-103">
              <img src={IMAGES.bono2} alt="Bono 2" className="w-full rounded-lg shadow-md" data-id="element-104" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-105">
              <div className="uppercase text-sm font-bold text-purple-600 tracking-wider mb-2" data-id="element-106">
                🎁 Bono 2
              </div>
              <h3 className="text-2xl font-extrabold text-gray-900 mb-2" data-id="element-107">
                100 Juegos Extra para Compartir en Familia
              </h3>
              <p className="text-lg text-gray-600 mb-4" data-id="element-108">
                Más momentos para disfrutar con hijos y nietos.
              </p>
              <p className="text-xl font-bold text-gray-400 line-through" data-id="element-109">
                Valor: $29
              </p>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-blue-50 rounded-2xl p-6 md:p-8 border-2 border-blue-200 mb-8 flex flex-col md:flex-row items-center gap-8 shadow-lg relative overflow-hidden" data-id="element-110">
            <div className="absolute top-4 right-4 bg-red-600 text-white font-bold py-1 px-3 rounded-full text-sm transform rotate-12" data-id="element-111">
              ¡GRATIS HOY!
            </div>
            <div className="w-full md:w-1/3" data-id="element-112">
              <img src={IMAGES.bono3} alt="Bono 3" className="w-full rounded-lg shadow-md" data-id="element-113" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-114">
              <div className="uppercase text-sm font-bold text-blue-600 tracking-wider mb-2" data-id="element-115">
                🎁 Bono 3
              </div>
              <h3 className="text-2xl font-extrabold text-gray-900 mb-2" data-id="element-116">
                50 Acertijos para Conversar con Hijos y Nietos
              </h3>
              <p className="text-lg text-gray-600 mb-4" data-id="element-117">
                Diversión, conversación y recuerdos inolvidables.
              </p>
              <p className="text-xl font-bold text-gray-400 line-through" data-id="element-118">
                Valor: $19
              </p>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-yellow-50 rounded-2xl p-6 md:p-8 border-2 border-yellow-200 mb-8 flex flex-col md:flex-row items-center gap-8 shadow-lg relative overflow-hidden" data-id="element-119">
            <div className="absolute top-4 right-4 bg-red-600 text-white font-bold py-1 px-3 rounded-full text-sm transform rotate-12" data-id="element-120">
              ¡GRATIS HOY!
            </div>
            <div className="w-full md:w-1/3" data-id="element-121">
              <img src={IMAGES.bono4} alt="Bono 4" className="w-full rounded-lg shadow-md" data-id="element-122" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-123">
              <div className="uppercase text-sm font-bold text-yellow-600 tracking-wider mb-2" data-id="element-124">
                🎁 Bono 4
              </div>
              <h3 className="text-2xl font-extrabold text-gray-900 mb-2" data-id="element-125">
                Versión con Letra Gigante
              </h3>
              <p className="text-lg text-gray-600 mb-4" data-id="element-126">
                Máxima comodidad para leer sin esfuerzo.
              </p>
              <p className="text-xl font-bold text-gray-400 line-through" data-id="element-127">
                Valor: $29
              </p>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-orange-50 rounded-2xl p-6 md:p-8 border-2 border-orange-200 mb-12 flex flex-col md:flex-row items-center gap-8 shadow-lg relative overflow-hidden" data-id="element-128">
            <div className="absolute top-4 right-4 bg-red-600 text-white font-bold py-1 px-3 rounded-full text-sm transform rotate-12" data-id="element-129">
              ¡GRATIS HOY!
            </div>
            <div className="w-full md:w-1/3" data-id="element-130">
              <img src={IMAGES.bono5} alt="Bono 5 - Gimnasia Cerebral" className="w-full rounded-lg shadow-md" data-id="element-131" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-132">
              <div className="uppercase text-sm font-bold text-orange-600 tracking-wider mb-2" data-id="element-133">
                🎁 Bono 5
              </div>
              <h3 className="text-2xl font-extrabold text-gray-900 mb-2" data-id="element-134">
                Gimnasia Cerebral
              </h3>
              <p className="text-lg text-gray-600 mb-4" data-id="element-135">
                Ejercicios divertidos para un cerebro más ágil y saludable.
              </p>
              <p className="text-xl font-bold text-gray-400 line-through" data-id="element-136">
                Valor: $15
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-137">
            <button onClick={scrollToCheckout} className="w-full max-w-2xl mx-auto bg-green-600 hover:bg-green-500 text-white font-extrabold text-2xl py-5 px-8 rounded-lg shadow-[0_8px_0_rgb(22,101,52)] hover:shadow-[0_4px_0_rgb(22,101,52)] hover:translate-y-1 transition-all flex items-center justify-center gap-3" data-id="element-138">
              ¡SÍ, QUIERO TODO ESTO AHORA! <ChevronRight size={28} data-id="element-139" />
            </button>
          </div>
        </div>
      </section>

      {/* Price / Offer Section */}
      <section id="comprar" className="py-16 px-4 bg-gray-900 text-white" data-id="element-140">
        <div className="max-w-3xl mx-auto" data-id="element-141">
          <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-yellow-400 relative" data-id="element-142">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-red-600 text-white font-bold py-2 px-6 rounded-full text-xl shadow-lg whitespace-nowrap" data-id="element-143">
              OFERTA ESPECIAL
            </div>

            <h2 className="text-3xl font-bold text-center mb-8 mt-4" data-id="element-144">
              Resumen de tu pedido:
            </h2>

            <div className="space-y-3 mb-8 text-lg font-medium border-b-2 border-gray-200 pb-8" data-id="element-145">
              <div className="flex justify-between items-center" data-id="element-146">
                <span data-id="element-147">Producto principal</span>
                <span className="text-gray-400 line-through" data-id="element-148">$49</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-149">
                <span data-id="element-150">Bono 1</span>
                <span className="text-gray-400 line-through" data-id="element-151">$19</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-152">
                <span data-id="element-153">Bono 2</span>
                <span className="text-gray-400 line-through" data-id="element-154">$29</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-155">
                <span data-id="element-156">Bono 3</span>
                <span className="text-gray-400 line-through" data-id="element-157">$19</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-158">
                <span data-id="element-159">Bono 4</span>
                <span className="text-gray-400 line-through" data-id="element-160">$29</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-161">
                <span data-id="element-162">Bono 5</span>
                <span className="text-gray-400 line-through" data-id="element-163">$15</span>
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-164">
              <p className="text-xl text-gray-600 mb-2" data-id="element-165">
                Valor total: <span className="line-through" data-id="element-166">$160 USD</span>
              </p>
              <p className="text-lg font-bold text-red-600 mb-4" data-id="element-167">
                Hoy no pagarás $160. Ni siquiera pagarás $49.
              </p>
              <p className="text-xl mb-2" data-id="element-168">
                Hoy puedes acceder al paquete completo por solo:
              </p>
              <p className="text-6xl font-extrabold text-green-600 my-4" data-id="element-169">
                $12 USD
              </p>

              <div className="flex flex-wrap justify-center gap-4 text-sm font-bold text-gray-600 mt-6" data-id="element-170">
                <span className="bg-gray-100 px-3 py-1 rounded-full" data-id="element-171">
                  Pago único.
                </span>
                <span className="bg-gray-100 px-3 py-1 rounded-full" data-id="element-172">
                  Sin mensualidades.
                </span>
                <span className="bg-gray-100 px-3 py-1 rounded-full" data-id="element-173">
                  Acceso para siempre.
                </span>
                <span className="bg-gray-100 px-3 py-1 rounded-full flex items-center gap-1" data-id="element-174">
                  <Download size={16} data-id="element-175" /> Descarga inmediata.
                </span>
              </div>
            </div>

            <button onClick={() => {
            window.location.href = CHECKOUT_URL;
          }} className="w-full bg-green-600 hover:bg-green-500 text-white font-extrabold text-2xl md:text-3xl py-6 px-4 rounded-xl shadow-[0_10px_0_rgb(22,101,52)] hover:shadow-[0_5px_0_rgb(22,101,52)] hover:translate-y-1 transition-all flex flex-col items-center justify-center gap-2 animate-pulse" data-id="element-176">
              <span data-id="element-177">¡QUIERO DESCARGAR MENTE EN ACCIÓN AHORA!</span>
              <span className="text-sm font-normal" data-id="element-178">
                Click aquí para ir al pago seguro
              </span>
            </button>

            <div className="mt-6 flex justify-center" data-id="element-179">
              <img src="https://cdn-icons-png.flaticon.com/512/196/196566.png" alt="Pagos Seguros" className="h-8 opacity-50 grayscale" data-id="element-180" />
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-181">
            <h3 className="text-2xl font-bold text-yellow-400 mb-4" data-id="element-182">
              ¿Por qué este precio es tan bajo?
            </h3>
            <p className="text-lg text-gray-300" data-id="element-183">
              Porque queremos que cualquier familia pueda acceder fácilmente a
              este material y comenzar hoy mismo. Esta promoción es exclusiva
              por tiempo limitado.
            </p>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 px-4 bg-white" data-id="element-184">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 bg-blue-50 p-8 rounded-2xl border-2 border-blue-200" data-id="element-185">
          <div className="w-32 h-32 shrink-0 bg-blue-600 rounded-full flex items-center justify-center text-white shadow-lg" data-id="element-186">
            <ShieldCheck size={64} data-id="element-187" />
          </div>
          <div data-id="element-188">
            <h2 className="text-3xl font-extrabold text-gray-900 mb-4" data-id="element-189">
              Garantía de Satisfacción de 7 Días
            </h2>
            <p className="text-lg text-gray-700 mb-4" data-id="element-190">
              Queremos que realices tu compra con total tranquilidad.
            </p>
            <p className="text-lg text-gray-700 mb-4" data-id="element-191">
              Si durante los próximos 7 días consideras que el material no
              cumple con tus expectativas, solo escríbenos y te devolveremos el
              100% de tu dinero.
            </p>
            <p className="font-bold text-blue-800" data-id="element-192">
              Sin preguntas complicadas. Sin riesgos.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-193">
        <div className="max-w-3xl mx-auto" data-id="element-194">
          <h2 className="text-4xl font-extrabold text-center mb-12" data-id="element-195">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-6" data-id="element-196">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-197">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-198">
                ¿Es un libro físico?
              </h3>
              <p className="text-gray-700" data-id="element-199">
                No. Recibirás un archivo PDF descargable para imprimir las veces
                que desees.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-200">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-201">
                ¿Cómo lo recibo?
              </h3>
              <p className="text-gray-700" data-id="element-202">
                Inmediatamente después del pago podrás descargar todo el
                contenido.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-203">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-204">
                ¿Necesito internet para usarlo?
              </h3>
              <p className="text-gray-700" data-id="element-205">
                Solo para descargar el material. Después podrás imprimirlo y
                utilizarlo sin conexión.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-206">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-207">
                ¿Puedo imprimirlo varias veces?
              </h3>
              <p className="text-gray-700" data-id="element-208">
                Sí. Podrás imprimir únicamente las páginas que quieras y cuantas
                veces lo necesites.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-209">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-210">
                ¿En qué tamaño viene?
              </h3>
              <p className="text-gray-700" data-id="element-211">
                Formato A4 de alta calidad. Compatible con cualquier impresora
                doméstica o imprenta.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final Summary */}
      <section className="py-16 px-4 bg-gray-900 text-white text-center border-t-8 border-red-600" data-id="element-212">
        <div className="max-w-2xl mx-auto" data-id="element-213">
          <h2 className="text-3xl font-bold mb-8" data-id="element-214">
            Hoy recibes TODO esto por solo…
          </h2>

          <div className="text-left max-w-sm mx-auto space-y-4 text-xl font-medium mb-10" data-id="element-215">
            <div className="flex items-center gap-3" data-id="element-216">
              <Check className="text-green-400" data-id="element-217" /> Más de 500 juegos.
            </div>
            <div className="flex items-center gap-3" data-id="element-218">
              <Check className="text-green-400" data-id="element-219" /> 5 Bonos Exclusivos.
            </div>
            <div className="flex items-center gap-3" data-id="element-220">
              <Check className="text-green-400" data-id="element-221" /> Acceso inmediato.
            </div>
            <div className="flex items-center gap-3" data-id="element-222">
              <Check className="text-green-400" data-id="element-223" /> Descarga en PDF.
            </div>
            <div className="flex items-center gap-3" data-id="element-224">
              <Check className="text-green-400" data-id="element-225" /> Garantía de 7 días.
            </div>
          </div>

          <p className="text-2xl mb-4" data-id="element-226">Todo por solo:</p>
          <p className="text-6xl font-extrabold text-green-500 mb-8" data-id="element-227">$12 USD</p>

          <button onClick={scrollToCheckout} className="w-full bg-green-600 hover:bg-green-500 text-white font-extrabold text-2xl py-5 px-8 rounded-lg shadow-[0_8px_0_rgb(22,101,52)] hover:shadow-[0_4px_0_rgb(22,101,52)] hover:translate-y-1 transition-all" data-id="element-228">
            ¡QUIERO DESCARGAR MENTE EN ACCIÓN AHORA!
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-gray-500 text-center py-8 text-sm" data-id="element-229">
        <p data-id="element-230">
          © {new Date().getFullYear()} Mente en Acción™. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-231">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>

      {/* Recent Purchase Pop-up */}
      <AnimatePresence data-id="element-232">
        {showPopup && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} className="fixed bottom-4 left-4 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-center gap-4 z-50 max-w-sm" data-id="element-233">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-234">
              <Check className="text-green-600" size={24} data-id="element-235" />
            </div>
            <div data-id="element-236">
              <p className="text-sm text-gray-600" data-id="element-237">Alguien acaba de comprar</p>
              <p className="font-bold text-gray-900" data-id="element-238">
                {currentPurchase.name} de {currentPurchase.country}
              </p>
              <p className="text-xs text-gray-500 flex items-center gap-1 mt-1" data-id="element-239">
                <Clock size={12} data-id="element-240" /> Hace unos minutos
              </p>
            </div>
            <button onClick={() => setShowPopup(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-241">
              <X size={16} data-id="element-242" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}